import { motion } from 'framer-motion';

const ticks = [
  { label: 'Robots Active', val: '24,847' },
  { label: 'Proofs/sec', val: '3,421' },
  { label: 'Receipts Issued', val: '91.2M' },
  { label: 'nDATA-R Tokens', val: 'LIVE' },
  { label: 'Avg Inference', val: '312ms' },
  { label: 'CBC Safety', val: 'ACTIVE' },
  { label: 'Network Uptime', val: '99.97%' },
  { label: 'Verified Policies', val: '8,204' },
];

export default function StatsTicker() {
  const items = [...ticks, ...ticks]; // doubled for seamless loop
  return (
    <div
      className="ticker-wrap border-y py-3 relative z-10"
      style={{ background: 'rgba(0,0,0,0.6)', borderColor: 'rgba(0, 240, 255, 0.08)' }}
      data-testid="stats-ticker"
    >
      <div className="ticker-inner gap-12">
        {items.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-3 px-6">
            <span
              className="w-1.5 h-1.5 rounded-full flex-shrink-0"
              style={{ background: item.val === 'LIVE' || item.val === 'ACTIVE' ? '#00FF88' : '#00F0FF' }}
            />
            <span className="font-mono text-[#555] text-xs tracking-[0.2em] uppercase">{item.label}</span>
            <span
              className="font-mono text-xs font-semibold tracking-wider"
              style={{ color: item.val === 'LIVE' || item.val === 'ACTIVE' ? '#00FF88' : '#00F0FF' }}
            >
              {item.val}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
